import { Box, Container } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { NavItem, SideNav } from '../../foundation/shared/components/side-nav';

const navItems: NavItem[] = [
  { label: 'General', path: '' },
  { label: 'Notifications', path: 'notifications' },
  { label: 'API Management', path: 'api-management' }
];

const getActiveTab = (items: NavItem[], pathname: string) => {
  return (
    items.find((item) => {
      if (item.path === '') {
        return pathname === '/settings';
      } else {
        return pathname.includes(item.path);
      }
    })?.path || navItems[0].path
  );
};

export const Settings: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleTabChange = (path: string) => {
    navigate(path); // Navigate to the sub-route
  };

  return (
    <Container maxWidth="lg">
      <Box display="flex" mt={4}>
        {/* Side Navigation */}
        <Box width="20%">
          <SideNav
            navItems={navItems}
            activeTab={getActiveTab(navItems, location.pathname)}
            onTabChange={(path) => handleTabChange(path)}
          />
        </Box>

        {/* Content Area */}
        <Box flex={1} ml={4}>
          <Outlet />
        </Box>
      </Box>
    </Container>
  );
};
